import { fetchUserInfo } from "@features/auth/api/request";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useApplyForm } from "../model/useApplyForm";
import { CompanyInfoFields } from "./CompanyInfoFields";
import { ContactInfoFields } from "./ContactInfoFields";
import { PaymentSection } from "./PaymentSection";
import { PlanSelector } from "./PlanSelector";
import { TermsSection } from "./TermsSection";

export const ApplyForm = () => {
  const { form, isPaymentPending } = useApplyForm();

  const { data: userInfo } = useQuery({
    queryKey: ["userInfo"],
    queryFn: fetchUserInfo,
  });

  useEffect(() => {
    if (userInfo) {
      form.setFieldValue("firstName", userInfo.user.first_name);
      form.setFieldValue("lastName", userInfo.user.last_name);
      form.setFieldValue("countryNumber", userInfo.user.phone_number_country_code ?? 82);
      form.setFieldValue("phoneNumber", userInfo.user.phone_number);
      form.setFieldValue("email", userInfo.user.email);
    }
  }, [userInfo, form.setFieldValue]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        form.handleSubmit();
      }}
      className="flex flex-col gap-8 mt-8"
    >
      <CompanyInfoFields form={form} />
      <ContactInfoFields form={form} />
      <PlanSelector form={form} />
      <TermsSection form={form} />
      <form.Subscribe selector={(state) => ({ plan: state.values.plan })}>
        {({ plan }) => <PaymentSection form={form} plan={plan} isPaymentPending={isPaymentPending} />}
      </form.Subscribe>
    </form>
  );
};
